(function() {
    /**
     * Cookies module.
     * @module orb/cookies
     */
    'use strict';

    var bbccookies = {};

    bbccookies.POLICY_REFRESH_DATE_MILLIS = new Date(2015, 4, 21, 0, 0, 0, 0).getTime();
    var POLICY_EXPIRY_COOKIENAME = 'ckns_policy_exp';

    var POLICYCOOKIENAME = 'ckns_policy',
        DEFAULTPOLICY = {
            ads: true,
            personalisation: true,
            performance: true,
            necessary: true
        },
        policyCache = {},
        bbccookies_jars = {
            "personalisation": "ckps_.+|X-AB-iplayer-.+|ACTVTYMKR|BBC_EXAMPLE_COOKIE|BBCIplayer|BBCiPlayerM|BBCIplayerSession|BBCMediaselector|BBCPostcoder|bbctravel|CGISESSID|ed|food-view|forceDesktop|h4|IMRID|locserv|MyLang|myloc|NTABS|ttduserPrefs|V5|WEATHER|BBCScienceDiscoveryPlaylist_.+|bitratePref|correctAnswerCount|genreCookie|highestQuestionScore|incorrectAnswerCount|longestStreak|MSCSProfile|programmes-oap-expanded|quickestAnswer|score|servicePanel|slowestAnswer|totalTimeForAllFormatted|v|BBCwords|score|correctAnswerCount|highestQuestionScore|hploc|BGUID|BBCWEACITY|mstouch|myway|BBCNewsCustomisation|cbbc_anim|cbeebies_snd|bbcsr_usersx|cbeebies_rd|BBC-Latest_Blogs|zh-enc|pref_loc|m|bbcEmp.+|recs-.+|_lvd2|_lvs2|tick|_fcap_CAM1|_rcc2",
            "performance": "ckpf_.+|optimizely.*|BBCLiveStatsClick|id|_em_.+|cookies_enabled|mbox|mbox-admin|mc_.+|omniture_unique|s_.+|sc_.+|adpolicyAdDisplayFrequency|s1|ns_session|ns_cookietest|ns_ux|NO-SA|tr_pr1|gvsurvey|bbcsurvey|si_v|sa_labels|obuid|mm_.+|mmid|mmcore.+|mmpa.+",
            "ads": "ckad_.+|rsi_segs|c",
            "necessary": "ckns_.+|BBC-UID|blq\\.dPref|SSO2-UID|BBC-H2-User|rmRpDetectReal|bbcComSurvey|IDENTITY_ENV|IDENTITY|IDENTITY-HTTPS|IDENTITY_SESSION|BBCCOMMENTSMODULESESSID|bbcBump.+|IVOTE_VOTE_HISTORY|pulse|BBCPG|BBCPGstat|ecos\\.dt"
        };

    bbccookies.cookieOvenRequest = function(xhr, url, done) {
        // make an xhr request to the cookieOvenUrl
        try {
            xhr.open('GET', url, true);
            xhr.send();
        } catch (error) {
          if(done){
            done(error); //edge case not handled by XMLHttpRequest
          }
        }
    };

    function cookieOvenUrl(tld, name, value) {
        return window.orb.partialCookieOvenUrl + '.' + tld + '/' + name + '/' + value;
    }

    function handleCookieOvenError(msg, done) {
      if (done) {
        done(new Error(msg));
      }
    }

    function setupCookieOventXHR(done){
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.onload = function() {
          if (done) {
            done(null, xhr.status);
          }
      };
      xhr.onerror = function(error) {
          handleCookieOvenError('Request to cross domain cookie service encountered an error with code' + xhr.status + '. ' + error, done);
      };
      xhr.onabort = function() {
          handleCookieOvenError('Request to cross domain cookie service was aborted.', done);
      };
      xhr.ontimeout = function() {
          handleCookieOvenError('Request to cross domain cookie service timed out.', done);
      };
      return xhr;
    }

    function domainSwitcher(domain){
      var domainFlipper = {
          'com': 'co.uk',
          'co.uk': 'com'
      };
      var tld = domain.match(/(co.uk|com)/)[0];
      return domainFlipper[tld];
    }

    bbccookies.cookieOvenClient = function(name, value, currentDomain, done) {

        // only try this if we have an environment that supports XHR properly
        if ('withCredentials' in new XMLHttpRequest()) {
            var allowedXDomainCookieNames = [POLICYCOOKIENAME];
            try {
                if (!currentDomain) {
                    throw new Error('Cannot make request to cross domain cookie service when domain is not set.');
                }
                if (allowedXDomainCookieNames.indexOf(name) <= -1) {
                    throw new Error('Cookie name is not in the whitelist accepted by the cross domain cookie service.');
                }

                var otherTld = domainSwitcher(currentDomain);
                var xhr = setupCookieOventXHR(done);
                var url = cookieOvenUrl(otherTld, name, value)
                bbccookies.cookieOvenRequest(xhr, url, done);

            } catch (error) {
                if (done) {
                    done(error);
                }
            }
        } else {
            done(new Error('Cannot make request to cross domain cookie service as this browser does not support XmlHttpRequest with credentials.'));
        }
    };

    /**
     *  Sets a specified cookie to a value, with optional options
     *  @public
     *  @param {string} name - The name of the cookie to be set. When second argument (value) is not set, this parameter
     *  can be used to set the cookie using a raw cookie string
     *  @param {string} [value] - The value the cookie will be set to.
     *  @param {object} [options] - Security (domain/path/secure) options and setting expiry time
     *  @param {date} [options.expiry = End Of Session] - The date on which the cookie will be removed by the browser
     *  @param {boolean} [options.secure] - If true, the cookie will be transmitted only over secure protocol as https
     *  @param {string} [options.domain = Host of current document] - The domain from which the cookie will be readable.
     *  E.g., "example.com",".example.com" (includes all subdomains) or "subdomain.example.com"; if not specified,
     *  defaults to the host portion of the current document location.
     *  @param {string} [options.path = current path of current document] - The path from which the cookie will be readable.
     * */
    bbccookies.set = function(name, value, options, done) {
        var cookieName, cookieString;
        if (value !== undefined) {
            // We're being used in key-value mode
            cookieName = sanitiseKey(name);
            cookieString = generateCookieString(cookieName, value, options);
            var crossDomainEnabled = options && options.crossDomainEnabled;
            if (bbccookies.isAllowed(cookieName) && crossDomainEnabled) {
                bbccookies.cookieOvenClient(name, value, options.domain, done);
            }
        } else {
            // We've been given a full cookie string ready to set
            cookieName = getCookieName(name);
            cookieString = name;
        }

        if (bbccookies.isAllowed(cookieName)) {
            document.cookie = cookieString;
        }
    };

    /**
     * Checks to see if the specified cookie name is allowed under the current browser/user's preferences.
     * @param {string} cookieName - The name of the cookie
     * @returns {boolean} True if a cookie with this name can be set under the current preferences
     */
    bbccookies.isAllowed = function(cookieName) {
        var policy,
            list,
            allowed;

        policy = bbccookies.readPolicy();
        list = getAllowedList(policy);
        allowed = list.test(cookieName);

        return allowed;
    };

    /**
     * Gets the current browser/user's cookie preferences
     * @param {string} [categoryName] - the category of cookie preferences to inspect. Should be "ads",
     * "personalisation", "performance" or "necessary"
     * @returns {Object|boolean} If catgeoryName is not specified, returns a preferences object, with keys "ads",
     * "personalisation", "performance" and "necessary", with a boolean value, indicating if cookies in that category
     * can be set. If categoryName is specified, returns a boolean value directly.
     */
    bbccookies.readPolicy = function(categoryName) {
        var policy = decompilePolicyCookie();
        if (categoryName) {
            return policy[categoryName];
        } else {
            return policy;
        }
    };

    /**
     * Gets the current browser/user's cookie preferences as a string suitable for analytics reporting
     * @returns {Object|boolean} Returns a string representing the cookie preferences
     */
    bbccookies.analyticsPolicyString = function() {
        var policy = decompilePolicyCookie();
        return 'ad' + +policy.ads + 'ps' + +policy.personalisation + 'pf' + +policy.performance
    };

    /**
     * Gets the value of a cookie at a specified key. If a key is not specified, returns the contents of document.cookie
     * @returns {string}
     */
    bbccookies.get = function(key) {
        if (!key) {
            return document.cookie;
        }
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    };

    bbccookies.isCookiePolicySet = function() {
        return bbccookies.get(POLICYCOOKIENAME) !== null;
    };


    /**
     * Set default cookie preferences for all categories on this current domain
     */
    bbccookies.setDefaultCookiesSingleDomain = function() {
        writePolicy(DEFAULTPOLICY, false);
    };

    /**
     * Sets the user/browser's cookie preferences for a specified category.
     * @param {string} categoryName - the name of the category
     * @param {boolean} preferenceValue - true for opt-in, false for opt-out
     * @param {boolean} disableCrossDomain - optional, true if cross-domain cookies should be disabled
     * @param {function} done - optional, callback function
     * @private
     */
    bbccookies._setPolicy = function(categoryName, preferenceValue, disableCrossDomain, done) {
        var policy = bbccookies.readPolicy();
        policy[categoryName] = !!preferenceValue;

        var isCrossDomainEnabled = !disableCrossDomain;

        writePolicy(policy, isCrossDomainEnabled, done);
    };

    /**
     * @method bbcookies.cookiesEnabled
     * @public
     * @returns {boolean} true if the browser has cookie support, otherwise false
     */
    bbccookies.cookiesEnabled = function() {
            var cname = 'ckns_cookietest' + Math.floor(Math.random() * 100000);
            this.set(cname, '1');

            if (this.get(cname)) {
                this.delete(cname);
                return true;
            }
            return false;
        }
        /**
         * Deletes a the cookie with a specified key.
         * @param {string} key - The name of cookie to remove
         * @param {string} [domain] - the domain from which to remove the cookie
         */
    bbccookies.delete = function(key, options) {
        key = sanitiseKey(key);
        unsanitisedDelete(key, options);
    }

    bbccookies.del = bbccookies.delete;

    //deletes a cookie without sanitising the key name
    function unsanitisedDelete(key, options) {
        if (key !== undefined) {
            //need to write using document.cookie as set won't allow us to set a cookie
            var opts = {}
            opts.expires = new Date(0);
            if (options) {
                opts.domain = options.domain;
                opts.path = options.path;
            }
            document.cookie = generateCookieString(key, "removed", opts);
        } else {
            return null;
        }
    }

    bbccookies._crunch = function() {
        //look through document.cookie for keys matching performance(initially), call delete on each one
        //do a find and replace, doesn't work
        deleteEverywhere('');
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookieParts = cookies[i].split("=");
            var keyName = cookieParts[0].trim();
            if (!this.isAllowed(keyName)) {
                deleteEverywhere(keyName);
            }
        }
    }

    bbccookies._getCurrentDomain = function() {
        try {
            var domain = window.location.hostname.toLowerCase();
            return domain.match(/.*(bbc\.co\.uk|bbc\.com)\/*/)[1];
        } catch (err) {
            return undefined;
        }
    };

    //deletes on all paths and domains as part of the crunch
    function deleteEverywhere(key) {
        var parts = window.location.hostname.split('.');
        var partsLength = parts.length;
        unsanitisedDelete(key);
        deleteOnAllPaths(key);
        while (parts.length && '|co.uk|com|'.indexOf('|' + parts.join('.') + '|') === -1) {
            if (parts.length) {
                var domain = parts.join('.');
                unsanitisedDelete(key, {
                    domain: domain
                });
                deleteOnAllPaths(key, domain);
            }
            parts.shift();
        }
    }

    function deleteOnAllPaths(key, domain) {
        var paths = window.location.pathname.split('/');
        unsanitisedDelete(key, domain);
        while (paths.length) {
            var path = paths.join('/');
            if (path === '') path = '/';
            unsanitisedDelete(key, {
                domain: domain,
                path: path
            });
            unsanitisedDelete(key, {
                domain: '.' + domain,
                path: path
            });
            paths.pop();
        }
    }

    function getAllowedList(policy) {
        var cacheKey = JSON.stringify(policy);
        if (typeof(policyCache[cacheKey]) !== 'undefined') {
            return policyCache[cacheKey];
        }

        var whiteList = '';

        for (var cat in policy) {
            if (policy.hasOwnProperty(cat) && bbccookies_jars[cat]) {
                if (policy[cat] === true) {
                    whiteList += (whiteList ? '|' : '') + bbccookies_jars[cat];
                }
            }
        }
        policyCache[cacheKey] = new RegExp('^(' + (whiteList ? whiteList : '.*') + ')$', 'i');

        return policyCache[cacheKey];
    }

    function decompilePolicyCookie() {
        var pattern = new RegExp('(?:^|; ?)' + POLICYCOOKIENAME + '=(\\d)(\\d)(\\d)($|;)'),
            parts = document.cookie.match(pattern);

        if (parts) {
            return {
                ads: !!+parts[1],
                personalisation: !!+parts[2],
                performance: !!+parts[3],
                necessary: true
            };
        } else {
            return DEFAULTPOLICY;
        }
    }

    function nextYear() {
        var d = new Date();
        d.setYear(d.getFullYear() + 1);
        return d;
    }

    function writePolicy(policy, isCrossDomainEnabled, done) {
        var d = nextYear();
        var policyString = '' + (policy.ads ? 1 : 0) + (policy.personalisation ? 1 : 0) + (policy.performance ? 1 : 0);

        var currentDomain = bbccookies._getCurrentDomain();
        bbccookies.set(POLICYCOOKIENAME, policyString, {
            domain: currentDomain,
            path: '/',
            expires: d,
            crossDomainEnabled: isCrossDomainEnabled
        }, done);

        // expire this cookie one month after policy cookie
        var expires = new Date(d.getTime());
        expires.setMonth(expires.getMonth() + 1);

        bbccookies.set(POLICY_EXPIRY_COOKIENAME, d.getTime(), {
            domain: currentDomain,
            path: '/',
            expires: expires
        });

        return policy;
    }

    function getCookieName(cookieString) {
        var matches = ('' + cookieString).match(/^([^=]+)(?==)/); //(^_^)//

        return (matches && matches.length ? matches[0] : '');
    }

    function sanitiseKey(key) {
        key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
        key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
        return key;
    }

    function generateCookieString(key, value, options) {
        var theDomain = (options && options.domain) ? ';domain=' + options.domain : '';
        value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
        options = options || {};

        var cookieString = key + '=' + value;
        cookieString += options.path ? ';path=' + options.path : '';
        cookieString += options.domain ? ';domain=' + options.domain : '';
        cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
        cookieString += options.secure ? ';secure' : '';
        return cookieString;
    }

    /*!
     * contentloaded.js
     *
     * Author: Diego Perini (diego.perini at gmail.com)
     * Summary: cross-browser wrapper for DOMContentLoaded
     * Updated: 20101020
     * License: MIT
     * Version: 1.2
     *
     * URL:
     * http://javascript.nwbox.com/ContentLoaded/
     * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
     *
     */

    // @win window reference
    // @fn function reference
    function contentLoaded(win, fn) {

        var done = false,
            top = true,

            doc = win.document,
            root = doc.documentElement,
            modern = doc.addEventListener,

            add = modern ? 'addEventListener' : 'attachEvent',
            rem = modern ? 'removeEventListener' : 'detachEvent',
            pre = modern ? '' : 'on',

            init = function(e) {
                if (e.type === 'readystatechange' && doc.readyState != 'complete') return;
                (e.type === 'load' ? win : doc)[rem](pre + e.type, init, false);
                if (!done && (done = true)) fn.call(win, e.type || e);
            },

            poll = function() {
                try {
                    root.doScroll('left');
                } catch (e) {
                    setTimeout(poll, 50);
                    return;
                }
                init('poll');
            };

        if (doc.readyState === 'complete') fn.call(win, 'lazy');
        else {
            if (!modern && root.doScroll) {
                try {
                    top = !win.frameElement;
                } catch (e) {}
                if (top) poll();
            }
            doc[add](pre + 'DOMContentLoaded', init, false);
            doc[add](pre + 'readystatechange', init, false);
            win[add](pre + 'load', init, false);
        }

    }


    //this public method is deprecated but is used by the cookies settings page.
    bbccookies._getPolicy = bbccookies.readPolicy;

    //trim polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
    if (!String.prototype.trim) {
        (function() {
            // Make sure we trim BOM and NBSP
            var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            String.prototype.trim = function() {
                return this.replace(rtrim, '');
            };
        })();
    }
    //run crunch when the script is loaded
    bbccookies._crunch();

    contentLoaded(window, function() {
        bbccookies._crunch()
    });
    if (window.addEventListener) {
        window.addEventListener('beforeunload', function() {
            bbccookies._crunch()
        }, false);
    } else if (window.attachEvent) {
        window.attachEvent('onbeforeunload', function() {
            bbccookies._crunch()
        });
    } else {
        window.onbeforeunload = function() {
            bbccookies._crunch()
        };
    }

    window.bbccookies = bbccookies;
    define('orb/cookies', function() {
        return bbccookies;
    });
})();
